import mixpanel from 'mixpanel-browser';
import { MixPanelEvent, getEventName, MixPanelEventTypes, PlatformTypes } from './types';

const mixPanelNavHandler = (
  platform: PlatformTypes,
  moduleName: string,
  eventType: MixPanelEventTypes,
  pageName: string,
  selection: string
) => {
  const event = new MixPanelEvent(platform, moduleName, eventType, pageName, null, null, null, null, selection);
  mixpanel.track(getEventName(event), event);
};

export default mixPanelNavHandler;
